import testimonialPic1 from "../assets/testimonialPic1.png"
import testimonialPic2 from "../assets/testimonialPic2.png";
import testimonialPic3 from "../assets/testimonialPic3.png";

export const testimonials = [
    {
        name: 'James Pattinson',
        image: testimonialPic1,
        rating: 4,
        text: '“Lobortis leo pretium facilisis amet nisl at nec. Scelerisque risus tortor donec ipsum consequat semper consequat adipiscing ultrices.”',
    },
    {
        name: 'Greg Stuart',
        image: testimonialPic2,
        rating: 5,
        text: '“Vestibulum, cum nam non amet consectetur morbi aenean condimentum eget. Ultricies integer nunc neque accumsan laoreet. Viverra nibh ultrices.”',
    },
    {
        name: 'Trevor Mitchell',
        image: testimonialPic3,
        rating: 3,
        text: '“Ut tristique viverra sed porttitor senectus. A facilisis metus pretium ut habitant lorem. Velit vel bibendum eget aliquet sem nec, id sed. Tincidunt.”',
    },
];